import { GROUND_ROW, cutPit, fillRect, freeze, makeGrid, setCell, type EntitySpawn, type LevelDef } from "./types";

export function buildWorld14(): LevelDef {
  const width = 168;
  const grid = makeGrid(width, false);
  fillRect(grid, 0, GROUND_ROW, width, 2, "S");
  fillRect(grid, 0, 0, width, 2, "S");
  fillRect(grid, 0, 2, 2, GROUND_ROW - 2, "S");
  fillRect(grid, width - 2, 2, 2, GROUND_ROW - 2, "S");

  const entities: EntitySpawn[] = [];
  const pipes: LevelDef["pipes"] = [];

  fillRect(grid, 8, 9, 4, 1, "S");
  setCell(grid, 10, 9, "!");
  entities.push({ kind: "firebar", tx: 10, ty: 9, length: 6, speed: 1.6 });

  cutPit(grid, 16, 4, true);
  fillRect(grid, 18, 8, 2, 1, "S");
  entities.push({ kind: "podoboo", tx: 17 });
  entities.push({ kind: "podoboo", tx: 19 });

  fillRect(grid, 24, 6, 1, 7, "S");
  fillRect(grid, 28, 8, 6, 1, "S");
  entities.push({ kind: "firebar", tx: 30, ty: 8, length: 5, speed: -1.8 });

  cutPit(grid, 36, 5, true);
  fillRect(grid, 38, 10, 3, 1, "S");
  entities.push({ kind: "podoboo", tx: 37 });
  entities.push({ kind: "firebar", tx: 39, ty: 10, length: 4, speed: 2.1 });

  fillRect(grid, 46, 9, 8, 1, "#");
  setCell(grid, 48, 9, "?");
  setCell(grid, 51, 9, "!");

  fillRect(grid, 58, 4, 2, 9, "S");
  fillRect(grid, 64, 7, 5, 1, "S");
  entities.push({ kind: "firebar", tx: 66, ty: 7, length: 6, speed: 1.4 });

  cutPit(grid, 72, 6, true);
  fillRect(grid, 74, 9, 3, 1, "S");
  entities.push({ kind: "podoboo", tx: 73 });
  entities.push({ kind: "podoboo", tx: 76 });

  fillRect(grid, 82, 8, 10, 1, "S");
  entities.push({ kind: "firebar", tx: 86, ty: 8, length: 6, speed: -1.5 });
  fillRect(grid, 96, 5, 1, 8, "S");

  cutPit(grid, 100, 4, true);
  entities.push({ kind: "podoboo", tx: 101 });
  fillRect(grid, 106, 10, 6, 1, "S");
  setCell(grid, 108, 10, "?");

  fillRect(grid, 116, 6, 4, 1, "S");
  entities.push({ kind: "firebar", tx: 118, ty: 6, length: 5, speed: 1.9 });

  // Boss arena + bridge + axe
  fillRect(grid, 124, GROUND_ROW, 20, 2, "S");
  cutPit(grid, 132, 14, true);
  fillRect(grid, 132, GROUND_ROW, 12, 1, "B");
  setCell(grid, 144, GROUND_ROW, "A");
  fillRect(grid, 145, GROUND_ROW, 8, 2, "S");
  fillRect(grid, 148, GROUND_ROW - 5, 4, 5, "C");
  setCell(grid, 150, GROUND_ROW - 2, "D");

  entities.push({ kind: "boss", tx: 136, ty: GROUND_ROW });

  return {
    id: "1-4",
    worldLabel: "1-4",
    theme: "castle",
    time: 400,
    tiles: freeze(grid),
    entities,
    pipes,
    playerSpawn: { tx: 4, ty: GROUND_ROW },
    axe: { tx: 144, ty: GROUND_ROW },
    castleX: 148,
  };
}
